import { useState, useEffect } from "react";

enum SCREEN {
  DESKTOP = "DESKTOP",
  TABLET = "TABLET",
  MOBILE = "MOBILE",
}

function getScreenType(width: number): SCREEN {
  if (width >= 1024) return SCREEN.DESKTOP;
  if (width >= 768) return SCREEN.TABLET;
  return SCREEN.MOBILE;
}

export default function useScreenSize() {
  const [screen, setScreen] = useState(() => getScreenType(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      setScreen(getScreenType(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    screenType: screen,
    isDesktop: screen === SCREEN.DESKTOP,
    isTablet: screen === SCREEN.TABLET,
    isMobile: screen === SCREEN.MOBILE,
  };
}
